import { cn } from '@/lib/utils'

type DefaultColumnProps = {
    children?: React.ReactNode
    className?: string
}

const DefaultColumn = ({ children, className }: DefaultColumnProps) => {
    return (
        <p
            className={cn(
                'overflow-hidden text-xs whitespace-nowrap text-ellipsis',
                className
            )}
        >
            {children}
        </p>
    )
}

export default DefaultColumn